import React, { useState } from 'react';
import BaseLayout from './BaseLayout';
import './ScheduleManagement.css';

const ScheduleManagement = ({ onBack, onLogout }) => {
  // 오늘 날짜를 YYYY-MM-DD 형식으로 가져오는 함수
  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  const [showAddModal, setShowAddModal] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    date: getTodayDate(),
    startTime: '09:00',
    endTime: '18:00',
    description: ''
  });

  // 구글 캘린더 임베드 URL - 실제 프로젝트 캘린더
  const googleCalendarUrl = "https://calendar.google.com/calendar/embed?src=53ed62c99c453e9b07c0c217a8db07170da57924a7292874b1a345f2a47066aa%40group.calendar.google.com&ctz=Asia%2FSeoul&height=600&wkst=1&bgcolor=%23ffffff&showTitle=0&showPrint=0&showTabs=1&showCalendars=0&mode=MONTH";

  // 구글 캘린더에 새 이벤트 추가하는 URL
  const calendarId = "53ed62c99c453e9b07c0c217a8db07170da57924a7292874b1a345f2a47066aa@group.calendar.google.com";
  
  const handleAddEventPopup = () => {
    // 바로 상세 추가 기능으로 연결
    handleSubmitEventDirect();
  };

  const handleSubmitEventDirect = () => {
    // 기본 일정 정보로 구글 캘린더 상세 추가 페이지 열기
    const today = getTodayDate();
    const eventText = `새 일정 ${today} 09:00-18:00`;
    
    // 구글 캘린더에 바로 추가하는 URL 구성
    const quickAddUrl = `https://calendar.google.com/calendar/u/0/r/eventedit?text=${encodeURIComponent(eventText)}&src=${encodeURIComponent(calendarId)}`;
    
    // 새 창에서 열기
    const newWindow = window.open(quickAddUrl, '_blank', 'width=800,height=700');
    
    if (newWindow) {
      // 성공 메시지는 표시하지 않고 바로 캘린더 열기
    } else {
      alert('팝업이 차단되었습니다. 브라우저 설정에서 팝업을 허용해주세요.');
    }
  };

  const handleCloseModal = () => {
    setShowAddModal(false);
    setFormData({
      title: '',
      date: getTodayDate(),
      startTime: '09:00',
      endTime: '18:00',
      description: ''
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmitEvent = async () => {
    if (!formData.title || !formData.date) {
      alert('제목과 날짜는 필수입니다.');
      return;
    }

    try {
      // 구글 캘린더 Quick Add 방식 사용
      const eventText = createQuickAddText();
      
      // 구글 캘린더에 바로 추가하는 URL 구성
      const quickAddUrl = `https://calendar.google.com/calendar/u/0/r/eventedit?text=${encodeURIComponent(eventText)}&src=${encodeURIComponent(calendarId)}`;
      
      // 새 창에서 열기 (자동으로 이벤트가 미리 채워짐)
      const newWindow = window.open(quickAddUrl, '_blank', 'width=800,height=700');
      
      if (newWindow) {
        alert('📅 구글 캘린더에 일정 정보가 자동으로 입력되었습니다!\n\n"저장" 버튼만 클릭하시면 일정이 추가됩니다.');
        handleCloseModal();
      } else {
        alert('팝업이 차단되었습니다. 브라우저 설정에서 팝업을 허용해주세요.');
      }
    } catch (error) {
      console.error('이벤트 생성 중 오류:', error);
      alert('일정 추가 중 오류가 발생했습니다. 다시 시도해주세요.');
    }
  };

  // 구글 캘린더 Quick Add 텍스트 생성
  const createQuickAddText = () => {
    const { title, date, startTime, endTime, description } = formData;
    
    // 날짜 포맷 변환 (YYYY-MM-DD -> MM/DD/YYYY)
    const dateObj = new Date(date);
    const formattedDate = `${(dateObj.getMonth() + 1).toString().padStart(2, '0')}/${dateObj.getDate().toString().padStart(2, '0')}/${dateObj.getFullYear()}`;
    
    // Quick Add 텍스트 구성
    let quickText = title;
    
    if (startTime && endTime) {
      quickText += ` ${formattedDate} ${startTime}-${endTime}`;
    } else if (startTime) {
      quickText += ` ${formattedDate} ${startTime}`;
    } else {
      quickText += ` ${formattedDate}`;
    }
    
    if (description) {
      quickText += ` - ${description}`;
    }
    
    return quickText;
  };
    
  // 즉시 추가 기능 (구글 캘린더 앱 또는 브라우저에서 바로 추가)
  const handleQuickAdd = async () => {
    if (!formData.title || !formData.date) {
      alert('제목과 날짜는 필수입니다.');
      return;
    }

    try {
      // 구글 캘린더에 직접 추가하는 URL 생성
      const eventData = {
        action: 'TEMPLATE',
        text: formData.title,
        dates: formatDateForGoogle(formData.date, formData.startTime, formData.endTime),
        details: formData.description,
        location: '',
        trp: false,
        sprop: [
          'https://calendar.google.com',
          'name:구글 캘린더'
        ],
        src: calendarId
      };

      const params = new URLSearchParams();
      Object.entries(eventData).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach(v => params.append(key, v));
        } else if (value !== '') {
          params.append(key, value);
        }
      });

      const calendarUrl = `https://calendar.google.com/calendar/render?${params.toString()}`;
      
      // 바로 추가 시도
      window.open(calendarUrl, '_blank');
      
      // 성공 메시지
      setTimeout(() => {
        alert('📅 구글 캘린더가 열렸습니다!\n\n일정 정보가 미리 입력되어 있으니 "저장" 버튼만 클릭하시면 됩니다.');
        handleCloseModal();
      }, 500);

    } catch (error) {
      console.error('빠른 추가 중 오류:', error);
      alert('빠른 추가 중 오류가 발생했습니다. 일반 추가를 사용해주세요.');
    }
  };

  const formatDateForGoogle = (date, startTime, endTime) => {
    const startDateTime = startTime ? `${date}T${startTime}:00` : `${date}T09:00:00`;
    const endDateTime = endTime ? `${date}T${endTime}:00` : `${date}T18:00:00`;
    
    // Google Calendar format: YYYYMMDDTHHMMSS/YYYYMMDDTHHMMSS
    const formatDateTime = (dateTimeStr) => {
      return new Date(dateTimeStr).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
    };

    return `${formatDateTime(startDateTime)}/${formatDateTime(endDateTime)}`;
  };

  const headerActions = (
    <div className="schedule-actions">
      <button 
        className="add-event-button"
        onClick={handleAddEventPopup}
        title="새 일정 추가 팝업 열기"
      >
        ➕ 일정 추가
      </button>
    </div>
  );

  return (
    <BaseLayout 
      onBack={onBack} 
      onLogout={onLogout}
      title="일정 관리"
      headerActions={headerActions}
      className="schedule-management"
    >
      <div className="schedule-container">
        <div className="calendar-section">
          <div className="google-calendar-container">
            <iframe
              src={googleCalendarUrl}
              style={{ border: 0 }}
              width="100%"
              height="100%"
              frameBorder="0"
              scrolling="no"
              title="Google Calendar"
            ></iframe>
          </div>
        </div>
      </div>

      {/* 일정 추가 모달 */}
      {showAddModal && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>📅 새 일정 추가</h3>
              <button className="close-button" onClick={handleCloseModal}>✕</button>
            </div>
            
            <div className="modal-body">
              <div className="form-group">
                <label htmlFor="title">제목 *</label>
                <input
                  type="text"
                  id="title"
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                  placeholder="일정 제목을 입력하세요"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="date">날짜 *</label>
                <input
                  type="date"
                  id="date"
                  name="date"
                  value={formData.date}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="startTime">시작 시간</label>
                  <input
                    type="time"
                    id="startTime"
                    name="startTime"
                    value={formData.startTime}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="endTime">종료 시간</label>
                  <input
                    type="time"
                    id="endTime"
                    name="endTime"
                    value={formData.endTime}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="description">설명</label>
                <textarea
                  id="description"
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  placeholder="일정에 대한 상세 설명을 입력하세요"
                  rows="4"
                />
              </div>
            </div>

            <div className="modal-footer">
              <button className="cancel-button" onClick={handleCloseModal}>
                취소
              </button>
              <div className="submit-buttons">
                <button className="quick-add-button" onClick={handleQuickAdd}>
                  ⚡ 빠른 추가
                </button>
                <button className="submit-button" onClick={handleSubmitEvent}>
                  📝 상세 추가
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </BaseLayout>
  );
};

export default ScheduleManagement;